import { render, staticRenderFns } from "./presenceRecord.vue?vue&type=template&id=08f7f2c0&scoped=true&"
import script from "./presenceRecord.vue?vue&type=script&lang=js&"
export * from "./presenceRecord.vue?vue&type=script&lang=js&"
import style0 from "./presenceRecord.vue?vue&type=style&index=0&id=08f7f2c0&scoped=true&lang=css&"
import style1 from "./presenceRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7f2c0",
  null
  
)

export default component.exports